/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

const SKELETON_CARD_COUNT = 6

const TeamFinderResultsSkeleton = () => (
  <div css={gridStyle} data-testid='team-finder-skeleton'>
    {Array.from({ length: SKELETON_CARD_COUNT }).map((_, i) => (
      <div key={i} css={cardStyle} />
    ))}
  </div>
)

export default TeamFinderResultsSkeleton

const gridStyle = css`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
`
const cardStyle = css`
  height: 240px;
  border-radius: 12px;
  background-color: ${colors.SECONDARY_400};
  opacity: 0.5;
`
